import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { User } from '../models/user.model';
import { Category } from '../models/category.model';
import { Product } from '../models/product.model';
import { Plate } from '../models/plate.model';
import { Ingredient } from '../models/ingredient.model';
import { Post } from '../models/post.model';


@Injectable({
  providedIn: 'root'
})
export class ConnectionService {

  API_URL = 'https://api-analisis-costos-casa-grand.herokuapp.com/api/v1';
  LOGIN_URL = 'https://api-analisis-costos-casa-grand.herokuapp.com/auth/sign_in';

  headers = new HttpHeaders({
    'Content-Type': 'application/json; charset=utf-8',
    'uid': localStorage.getItem('uid'),
    'access-token': localStorage.getItem('access-token'),
    'client': localStorage.getItem('client'),
  });

  constructor(private _http: HttpClient) { }

  /***********************
        CATEGORIES
  ***********************/
  getCategories() {
    return this._http.get<Category[]>(`${this.API_URL}/categories`, { headers: this.headers })
  }

  addCategory(item) {
    return this._http.post(`${this.API_URL}/categories`, item, { headers: this.headers })
      .subscribe(
        data => {
          alert("Categoria Registrada Exitosamente");
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  updateCategory(item) {
    return this._http.put(`${this.API_URL}/categories/${item.id}`, item, { headers: this.headers })
      .subscribe(
        data => {
          alert("Categoria Actualizada Exitosamente");
          window.location.href = 'categories'
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  deleteCategory(item) {
    return this._http.delete(`${this.API_URL}/categories/${item.id}`, { headers: this.headers })
      .subscribe(
        data => {
          alert("Categoria Eliminada Exitosamente");
          window.location.href = 'categories'
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  /***********************
        PRODUCTS
  ***********************/
  getProducts() {
    return this._http.get<Product[]>(`${this.API_URL}/products`, { headers: this.headers })
  }

  getProduct(id) {
    return this._http.get<Product[]>(`${this.API_URL}/products/${id}`, { headers: this.headers })
  }

  addProduct(item) {
    return this._http.post(`${this.API_URL}/products`, item, { headers: this.headers })
      .subscribe(
        data => {
          alert("Producto Registrado Exitosamente");
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  updateProduct(item) {
    return this._http.put(`${this.API_URL}/products/${item.id}`, item, { headers: this.headers })
      .subscribe(
        data => {
          alert("Producto Actualizada Exitosamente");
          window.location.href = 'products'
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  deleteProduct(item) {
    return this._http.delete(`${this.API_URL}/products/${item.id}`, { headers: this.headers })
      .subscribe(
        data => {
          alert("Producto Eliminada Exitosamente");
          window.location.href = 'products'
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }


  /*************************
        INGREDIENTS
  ************************/

  getIngredients() {
    return this._http.get<Ingredient[]>(`${this.API_URL}/ingredients`, { headers: this.headers })
  }

  addIngredient(item) {
    return this._http.post(`${this.API_URL}/ingredients`, item, { headers: this.headers })
      .subscribe(
        data => {
          alert("Ingrediente Registrado Exitosamente");
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  updateIngredient(item) {
    console.log(item)
    return this._http.put(`${this.API_URL}/ingredients/${item.id}`, item, { headers: this.headers })
      .subscribe(
        data => {
          alert("Ingrediente Actualizada Exitosamente");
          window.location.href = 'ingredients'
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }

  deleteIngredient(item) {
    return this._http.delete(`${this.API_URL}/ingredients/${item.id}`, { headers: this.headers })
      .subscribe(
        data => {
          alert("Ingrediente Eliminado Exitosamente");
          window.location.href = 'ingredients'
        },
        error => {
          alert("Error, por favor avisar al desarrollador");
        },
      );
  }


  authUser(item) {
    return this._http.post<User[]>(this.LOGIN_URL, item,
      { observe: 'response' }).subscribe(res => {
        localStorage.setItem('client', res.headers.get('client'));
        localStorage.setItem('uid', res.headers.get('uid'));
        localStorage.setItem('access-token', res.headers.get('access-token'));

        if (res.status == 200) {
          window.location.href = '/dashboard'
        }

      });
  }
}